import React from "react";
import "../Company/Vision.css";
import { useTranslation } from "react-i18next";

const Vision = () => {
  const { t, i18n } = useTranslation();

  // 현재 언어 가져오기
  const currentLanguage = i18n.language;

  return (
    <div className="sub-wrap">
      <div className="inner_page_title">Vision Roadmap</div>
      <div className="content">
        <div className="inner_vision_title">{t("vision.vision01")}</div>
        <div className="vision-box">
          <div className={`Vision-image ${currentLanguage}`}></div>
        </div>
      </div>
      <div className="content-box">
        <div className="inner_vision_title">{t("coretech.core08")}</div>
        <div className="tech-txt4">
          <div className={`coretech-image4 ${currentLanguage}`}></div>
        </div>
      </div>
    </div>
  );
};

export default Vision;
